var exports = {
  "k": "xe564cbfb--c64dee--container",
};

module.exports = exports;
